let configPromise = null;

export const getConfig = () => {
  if (!configPromise) {
    configPromise = fetch('/config.json')
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to load configuration');
        }
        return response.json();
      });
  }
  return configPromise;
}; 